/* eslint-disable */
// Disabling legacy file for now as audience_key chains upward.
//This is the entry point for the home component
import React, { FC, useContext, useEffect, useState } from 'react';
import injectSheet from 'react-jss';
import { useQuery } from '@apollo/react-hooks';

import styleSheet from './styles';
import { ProfileHeader_GQL } from './gqlQuery';
import AudienceProfileList from 'Containers/AudienceProfileList';
//import ProfileHeader from "Containers/Headers/ProfileHeader";
import ProfileHeader from 'Components/Headers/ProfileHeader';
import UserDetailsContext from 'Context/userDetailsContext';
import ListMembership from 'Containers/ListMembership';

import BackArrow from 'Assets/ui/backArrow.svg';
import { useRouter } from 'Utils/router';
import { Button } from 'Components/Buttons';

// Dashboards
import { ProfileDetails } from 'Containers/GoodData/dashboards';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';

interface Props {
  inst_id?: string;
  audience_key?: string;
  classes?: any;
  view?: string;
}

const AudienceDetails: FC<Props> = props => {
  const userDetails = useContext(UserDetailsContext);
  const history = useRouter().history;
  const {
    loading: profileHeaderLoading,
    error: profileHeaderError,
    data: profileHeaderData,
  } = useQuery(ProfileHeader_GQL, {
    variables: {
      inst_id: userDetails.instId,
      audience_key: props.audience_key,
    },
  });
  const {
    actions: { track },
  } = useContext(ProductAnalyticsContext);

  useEffect(() => {
    track('audience_profile_viewed', {
      audience_id: props.audience_key,
      screen: props.view,
    });
  }, []);

  return (
    <>
      <Button
        buttonType="goBack"
        onClick={() => {
          history.replace(
            (history.location.state && history.location.state.prevPath) ||
              '/inquiries/explore'
          );
        }}
      >
        <BackArrow />
      </Button>
      <ProfileHeader
        data={profileHeaderData}
        loading={profileHeaderLoading}
        error={profileHeaderError}
      />
      <div style={{ display: 'flex' }}>
        <div className={props.classes.group} style={{ margin: '0 24px 0 0' }}>
          <AudienceProfileList
            {...props}
            visitorType={
              profileHeaderData?.audience?.audience?.profile?.visitorType
            }
            inst_id={userDetails.instId}
            account_id={userDetails.accountId}
          />
        </div>
        <div className={props.classes.group} style={{ width: '100%' }}>
          <div>
            <ProfileDetails audienceKey={props.audience_key} />
          </div>
          <div>
            <ListMembership audience_key={props.audience_key} />
          </div>
        </div>
      </div>
    </>
  );
};

export default injectSheet(styleSheet)(AudienceDetails);
